import { Tooltip } from 'bootstrap';
import * as Style from './styles';

export const ListItemIcon = ({children, ...rest}) => {
    return(
        <Style.WrapperIcon {...rest}>
            {children}
        </Style.WrapperIcon>
    )
}